import { render, staticRenderFns } from "./TransferView.vue?vue&type=template&id=254c72f0&scoped=true&"
import script from "./TransferView.vue?vue&type=script&lang=js&"
export * from "./TransferView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c72f0",
  null
  
)

export default component.exports